import "select2";
import { coloris, init } from "@melloware/coloris";
export default function () {

    init();
    coloris({
        el: '.color-picker',
        theme: 'pill',
        theme: 'polaroid',
        formatToggle: true,
        closeButton: true,
        clearButton: true,
        closeLabel: 'Zamknij',
        clearLabel: 'Usuń',
        selectInput: false,
        formatToggle: false,
        format: 'hex',
        swatches: [
            '#264653',
            '#2a9d8f',
            '#e9c46a',
            '#f4a261',
            '#e76f51',
            '#d62828',
            '#023e8a',
            '#0077b6',
            '#0096c7',
            '#00b4d8',
            '#48cae4'
        ]

    });

    $('body').find('.chosen-select').each(function () {
        const $this = $(this);

        $this.children('option').each(function () {
            if ($(this).text().startsWith('---')) {
                $(this).attr('disabled', true);
            }
        });

        $this.select2({
            closeOnSelect: $this[0].multiple ? false : true,
            minimumResultsForSearch: 6,
            placeholder: $(this).attr('data-placeholder'),
            dropdownParent: $this.parent(),
            language: {
                errorLoading: function () {
                    return 'Nie można załadować wyników.';
                },
                inputTooLong: function (args) {
                    return "";
                },
                inputTooShort: function (args) {
                    return "";
                },
                loadingMore: function () {
                    return 'Trwa ładowanie …';
                },
                maximumSelected: function (args) {
                    return "";
                },
                noResults: function () {
                    return 'Brak wyników';
                },
                searching: function () {
                    return 'Trwa wyszukiwanie …';
                },
                removeAllItems: function () {
                    return 'Usuń wszystkie elementy';
                },
                removeItem: function () {
                    return 'Usuń element';
                },
                search: function () {
                    return 'Szukaj';
                }
            }
        });
    });
}